export const productQuestions = [
  { label: "Product name", value: "product", type: "string" },
  { label: "ASIN or UPC", value: "asin", type: "string" },
  { label: "Product URL", value: "url", type: "string" },
  {
    label: "Average selling price",
    value: "msrp",
    type: "float",
    icon: "money",
  },
  {
    label: "# of shipments last year",
    value: "shipments",
    type: "num",
  },
];
